var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0374 8.60403L10.7338 8.90594C10.7338 8.90594 10.0121 9.62356 8.04207 7.66474C6.07207 5.70593 6.79379 4.9883 6.79379 4.9883L6.985 4.79817C7.45604 4.32981 7.50044 3.57786 7.08948 3.02891L6.24883 1.90597C5.74018 1.22653 4.7573 1.13678 4.17429 1.71647L3.12789 2.75693C2.83881 3.04437 2.64509 3.41698 2.66858 3.83032C2.72868 4.8878 3.20713 7.16302 5.8769 9.81763C8.70808 12.6327 11.3645 12.7446 12.4508 12.6433C12.7944 12.6113 13.0933 12.4363 13.3341 12.1969L14.2811 11.2552C14.9204 10.6196 14.7401 9.52987 13.9222 9.08524L12.6485 8.39286C12.1115 8.10091 11.4572 8.18667 11.0374 8.60403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.86e08809b2e434760485a2d20e31cb5e.svg";
export { ForwardRef as ReactComponent };